import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        defaultFilter: '='
    },
    template: `
        <div class="table-filters">
            <form ng-submit="vm.applyFilter()" class="form form-filter">
                <div class="fields">
                    <form-row error="vm.list.errors.dateStart" class="row-flex02">
                        <label class="label">{{ 'auditLog.From' | translate }}</label>

                        <div class="items">
                            <datepicker-api ng-model="vm.filter.dateStart"></datepicker-api>
                        </div>
                        <form-row-error></form-row-error>
                    </form-row>
                    <form-row error="vm.list.errors.dateEnd" class="row-flex02">
                        <label class="label">{{ 'auditLog.To' | translate }}</label>
                        <div class="items">
                            <datepicker-api ng-model="vm.filter.dateEnd"></datepicker-api>
                        </div>
                        <form-row-error></form-row-error>
                    </form-row>
                    <form-row class="row-flex02">
                        <label class="label">{{ 'filter.Employee' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedEmployee"
                                ng-model="vm.filter.userId"
                                value-attribute="'id'"
                                placeholder="vm.$translate.instant('filter.Find an employee')"
                                query="vm.queryUsers(input)"
                            />
                        </div>
                    </form-row>
                    <form-row class="row-flex02">
                        <label class="label">{{ 'notificationLog.Recipient email' | translate }}</label>
                        <div class="items">
                            <input type="text" class="form-control" ng-model="vm.filter.recipient">
                        </div>
                    </form-row>
                    <form-row class="row-flex02">
                        <label class="label">{{ 'notificationLog.Status' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.status">
                                <option value="">{{ 'filter.All' | translate }}</option>
                                <option ng-repeat="option in vm.statuses" value="{{ option.value }}">{{ option.label | translate }}</option>
                            </select>
                        </div>
                    </form-row>
                </div>
                <ul class="actions01">
                    <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, SearchResource, UserResource, ROLE_CODE_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.filter = angular.copy(this.defaultFilter);
        this.SearchResource = SearchResource;
        this.UserResource = UserResource;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.employees = [];
        this.statuses = [
            { value: 'QUEUED', label: 'notificationLog.Queued' },
            { value: 'PUBLISHED', label: 'notificationLog.Sent' },
            { value: 'FAILED', label: 'notificationLog.Failed' }
        ];
    }

    $onInit () {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);
        this.initialFilter = angular.copy(this.defaultFilter);
        this.initialFilter.dateStart = currentDate.toISOString().split('T')[0];
        this.filter = angular.copy(this.initialFilter);
        this.applyFilter();
    }

    applyFilter () {
        this.list.fetch(this.filter).catch(() => {
            this.list.items = [];
        });
    }

    resetFilter () {
        this.filter = angular.copy(this.initialFilter || this.defaultFilter);
        this.applyFilter();
    }

    search () {
        if (!this.keyword.length) {
            this.employees = {};
            return;
        }
        this.SearchResource.getAutocompleteResults({ keyword: this.keyword }).$promise.then((results) => {
            this.employees = results.employees;
            this.searchCompleted = true;
        });
    }

    queryUsers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            name: input,
            pageSize: 0,
            privilegesCheck: false
        };

        return this.UserResource.getUsers({}, params).$promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/logs/notificationlog/filter/index.js